import { observable, action, flow } from 'mobx';
import { ajax, utils } from '@clouderwork/ywk';
import { IUserInfo, IBaseData, ISendMessagePrams } from '../../entity/user';
import { urlFn } from '@src/utils/index';
import { Toast } from 'antd-mobile';
import { withRole } from '@src/utils/residentNew';
import resident from '.';
import { async } from 'q';
import { toLogin } from '@src/utils/helper';

class User {
  // 当前用户信息
  @observable
  curUserInfo: any;
  @observable
  baseData: IBaseData = {};
  @observable baseCityList: IBaseData[] = [];

  @observable sendMsgFetching = 'init';

  constructor() {
    const flag = urlFn.getFirstPathName();
    console.log('resident store flag', flag, flag === 'resident');
    if (flag !== 'resident') return;
    this.getProfile();
    this.getBasicData();
    this.getCity();
  }
  /**
   * 设置当前用户信息
   * @param user 用户信息
   */
  @action.bound
  setUserInfo(user: IUserInfo) {
    this.curUserInfo = user;
  }

  /**
   * 获取用户信息
   * @param {boolean} fromEnt 来自企业版
   * @returns
   * @memberof User
   */
  @action.bound
  getProfile = flow(function* (this: User) {
    try {
      const fromEnt = utils.getQueryString('fromEnt') || utils.getQueryString('isResident');
      const profile = yield ajax.getJson('/resident/api/user', withRole({}, fromEnt ? 1 : 2));
      if (profile.error_code === 0) {
        this.curUserInfo = profile.user;
      } else {
        // 因为此接口和页面也可能在mobile端使用，所以检测是否ywk app环境
        if (
          (profile.response.status === 403 || (profile.response.data && +profile.response.data.error_code === 80001)) &&
          window.YwkHybrid.os.ywk
        ) {
          toLogin();
        }
      }
    } catch (error) {
      // 因为此接口和页面也可能在mobile端使用，所以检测是否ywk app环境
      if (
        (error.error_code === 80001 || (error.response && error.response.status === 403)) &&
        window.YwkHybrid.os.ywk
      ) {
        toLogin();
      }
      // Toast.fail('offer请求失败');
    }
  });
  // 储存公用常量数据
  @action.bound
  async getBasicData() {
    const res = await ajax.getJson('/resident/api/params', withRole({}, 2));
    if (res.error_code === 0) {
      this.baseData = res.params;
    }
  }

  // 向沃客信发送消息
  @action.bound
  async sendMessage(params: ISendMessagePrams) {
    const company_uuid = resident.user.curUserInfo && resident.user.curUserInfo.company_uuid;
    return await ajax.post(
      `/wokexin/api/v1/message.send${company_uuid ? '?usergroup_id=' + company_uuid : ''}`,
      params
    );
  }

  @action.bound
  async contactFirst(params: { role: string; offer_uuid: string }) {
    return await ajax.post('/resident/api/offers/contact/first', params);
  }

  // 获取我的简历
  @action.bound
  async getMyResume() {
    return ajax.getJson('/resident/api/resumes/mine', withRole({}, 2));
  }
  // 获取城市数据
  @action.bound
  getCity = flow(function* (this: User) {
    try {
      const res = yield ajax.getJson('/resident/api/citys', withRole({}));
      if (res.error_code === 0) {
        this.baseCityList = res.citys;
      }
    } catch (error) {
      Toast.fail('offer请求失败');
    }
  });
}

export default User;
